import { render, staticRenderFns } from "./ChatMessageInfo.vue?vue&type=template&id=4cfcf651&"
import script from "./ChatMessageInfo.vue?vue&type=script&lang=js&"
export * from "./ChatMessageInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageInfo.vue?vue&type=style&index=0&id=4cfcf651&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports